<script setup>
const props = defineProps({ error: Object });
const isChunkError = props.error?.message?.includes('Failed to fetch dynamically imported module');

useSeoMeta({ title: 'Gefest AI' }); // не даём "5xx" протекать в title

onMounted(() => {
    if (isChunkError) window.location.reload();
});
</script>

<template>
    <div class="min-h-screen bg-[#0F1113] text-white flex flex-col items-center justify-center p-4">
        <h1 class="text-4xl font-bold mb-4">Что-то пошло не так</h1>
        <p class="text-gray-400 mb-8 text-center max-w-md">
            Мы обновляем систему. Пожалуйста, обновите страницу или вернитесь на главную.
        </p>
        <button
            @click="handleError"
            class="px-6 py-3 bg-orange-500 text-white font-bold rounded-xl hover:bg-orange-600 transition"
        >
            Вернуться на главную
        </button>
    </div>
</template>
